export default __webpack_public_path__ + "static/media/kukai.d35f28b5.svg";